module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("ui " + _vm.customClass + " progress"),
    attrs: {
      "id": _vm.progressId
    }
  }, [_vm._m(0), _vm._v(" "), _vm._t("start-label")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "progress"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5ba593"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/semvue/components/Progress.vue
// module id = 145
// module chunks = 1